import { userProjectInteractionTypes } from '@/Models';
import Resources from '@/Resources.js';

export const tabKeys = {
    all: 'all',
    backed: 'backed',
    followed: 'followed',
};

export const keyToFilterMap = {
    [tabKeys.followed]: [
        userProjectInteractionTypes[userProjectInteractionTypes.followed].value,
    ],
    [tabKeys.backed]: [
        userProjectInteractionTypes[userProjectInteractionTypes.backed].value,
    ],
    [tabKeys.all]: [
        userProjectInteractionTypes[userProjectInteractionTypes.backed].value,
        userProjectInteractionTypes[userProjectInteractionTypes.followed].value,
    ],
};

export const buildCardActions = (projectId, isArchived, archiveActionPromise, restoreActionPromise) => {
    const archiveAction = async () => {
        await archiveActionPromise(projectId);
    };
    const restoreAction = async () => {
        await restoreActionPromise(projectId);
    };

    return [
        {
            title: Resources.BackerCenter.ArchiveProjectArchiveStatusLabel,
            fn: archiveAction,
            icon: 'box-archive',
            enabled: !isArchived,
        },
        {
            title: Resources.BackerCenter.RestoreProjectArchiveStatusLabel,
            fn: restoreAction,
            icon: 'box-archive',
            enabled: isArchived,
        },
    ].filter(action => action.enabled);
};
